/**
 * Taken from https://github.com/vercel/next.js/blob/canary/examples/with-sentry/pages/404.tsx
 *
 * It may be that the custom _error.tsx page won't work without also providing this 404.tsx page?
 * https://github.com/vercel/next.js/issues/12256
 */

import Error from "next/error";

export default function NotFound() {
	// Opinionated: do not record an exception in Sentry for 404
	return <Error statusCode={404} />;
}
